import React from 'react';
import { StarIcon } from 'lucide-react';
import { quickTestimonials } from '../data/testimonials';
export function QuickTestimonials() {
  return <section aria-label="Co mówią pedagodzy" className="bg-night py-16 sm:py-20" data-id="element-318" data-mp="3dpqmg13x0vns">
      <div className="mx-auto grid max-w-shell gap-9 px-5 sm:px-6 md:grid-cols-3 md:gap-8" data-id="element-319" data-mp="2zq8uxdz8j4aq">
        {quickTestimonials.map(item => <figure key={item.name} className="flex flex-col" data-id="element-320" data-mp="34roe10hur0qh">
            <div className="flex gap-0.5" aria-label="Ocena 5 na 5" data-id="element-321" data-mp="2pze8o9lzo4pa">
              {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-amber text-amber" aria-hidden="true" data-id="element-322" data-mp="2utiid0mn2qu2" data-mpi={index} />)}
            </div>
            <blockquote className="mt-5 font-serif text-lg italic leading-snug text-cream sm:text-xl" data-id="element-323" data-mp="2l130027fk08n">
              &bdquo;{item.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-auto pt-6 text-xs text-cream-muted" data-id="element-324" data-mp="2c16e28cfdfha">
              <span className="font-semibold text-cream-soft" data-id="element-325" data-mp="2c392wp1ud2kf">{item.name}</span> &middot; {item.role}{' '}
              &middot; {item.location}
            </figcaption>
          </figure>)}
      </div>
    </section>;
}